import { margauxMotinImages } from "../../../../../Assets/images/margaux-motin";
import React from "react";
import DecorationBox from "../../../../DecorationBox/DecorationBox";
import StyledDiv from "../../../../StyledDiv/StyledDiv";

export interface IInnovationProductMargauxMotinConfig {
  deco: string;
  productImage: string;
  renderTopImage?: () => React.ReactNode;
  renderBottomImage?: () => React.ReactNode;
  bgSvg: (color: string) => React.ReactNode;
  color: string;
  maxWidth: number;
  titleStyle?: React.CSSProperties;
}

export const innovationProductMargauxMotinConfig: IInnovationProductMargauxMotinConfig[] =
  [
    // 1 element
    {
      deco: margauxMotinImages.decoBox1,
      productImage: margauxMotinImages.productSpringCalme,
      renderTopImage: () => (
        <DecorationBox
          imageName="productSpringCalme"
          styles={{
            margin: "0 auto -17px",
            transform: "translateX(-40px)",
            position: "relative",
            zIndex: 1,
            mobile: {
              transform: "translate(27%, -3%)",
            },
          }}
          enableAnimation={true}
          animationType="slideUp"
          animationDelay={100}
          animationDistance={100}
          threshold={0.1}
        />
      ),
      renderBottomImage: () => (
        <DecorationBox
          imageName="decoBox1"
          styles={{
            position: "absolute",
            bottom: 0,
            left: 0,
            transform: "translate(-100%, -7%)",
            mobile: {
              transform: "translate(68%, 29%)",
              img: {
                maxWidth: "210px",
              },
            },
          }}
          enableAnimation={true}
          animationType="slideRight"
          animationDelay={500}
          animationDistance={200}
          threshold={0.1}
        />
      ),
      color: "#D0DF8F",
      maxWidth: 247,
      bgSvg: (color: string) => (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 0,
            overflow: "visible",
            pointerEvents: "none",
          }}
        >
          <StyledDiv
            as="svg"
            styles={{
              transform: "translate(-30%, 20%)",
              mobile: {
                transform: "translate(-18%, 15%)",
              },
            }}
            xmlns="http://www.w3.org/2000/svg"
            width="429"
            height="399"
            viewBox="0 0 429 399"
            fill="none"
          >
            <path
              d="M6.03671 285.627C-2.43292 241.904 -0.0111792 198.699 11.2558 162.139C23.5904 122.224 47.0831 93.7299 76.4874 72.4923C94.5051 59.4938 113.979 48.9769 133.429 38.5397C162.312 23.0447 192.027 8.31142 225.237 2.70568C236.149 0.835957 247.373 -0.0498011 258.844 0.238663C258.797 0.240758 258.727 0.231718 258.679 0.233811C285.74 0.889936 314.168 6.69791 341.547 22.6493C349.852 27.4845 358.191 33.334 366.344 40.2437C388.655 59.1625 419.461 97.2682 425.208 130.21C431.498 166.26 429.137 199.292 420.664 225.753C411.404 254.662 394.544 274.896 376.55 292.549C327.663 340.508 276.282 391.007 205.448 398.095C179.945 400.654 153.393 397.291 126.468 390.776C105.903 385.789 85.0016 380.909 64.874 368.315C57.9799 364.011 51.0951 358.714 44.5132 352.207C29.0315 336.93 10.5248 308.739 6.04956 285.621"
              fill={color}
            />
          </StyledDiv>
        </div>
      ),
    },
    // 2 element--------------------------------
    {
      deco: margauxMotinImages.decoBox2,
      productImage: margauxMotinImages.productCaliforniaCreatif,
      renderTopImage: () => (
        <DecorationBox
          imageName="decoBox2"
          styles={{
            marginBottom: -52,
            marginLeft: "auto",
            position: "relative",
            zIndex: 1,
            transform: "translate(-10%, -2%)",
            mobile: {
              marginBottom: -8,
              transform: "translate(-12%, 28%)",
              img: {
                maxWidth: "210px",
              },
            },
          }}
          enableAnimation={true}
          animationType="slideDown"
          animationDelay={500}
          animationDistance={100}
          threshold={0.1}
        />
      ),
      renderBottomImage: () => (
        <DecorationBox
          imageName="productCaliforniaCreatif"
          styles={{
            position: "absolute",
            bottom: 0,
            right: 38,
            // transform: "translate(-37%, -18%)",
            mobile: {
              // transform: "translate(-29%, 15%)",
            },
          }}
          enableAnimation={true}
          animationType="slideUp"
          animationDelay={100}
          animationDistance={100}
          threshold={0.1}
        />
      ),
      color: "#FF9A95",
      maxWidth: 268,
      titleStyle: {
        maxWidth: 148,
      },
      bgSvg: (color: string) => (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 0,
            overflow: "visible",
            pointerEvents: "none",
          }}
        >
          <StyledDiv
            as="svg"
            xmlns="http://www.w3.org/2000/svg"
            width="341"
            height="436"
            viewBox="0 0 341 436"
            fill="none"
            styles={{
              transform: "translate(-18%, 29%)",
              mobile: {
                transform: "translate(-13%, 33%) translateZ(0px) scale(1.2)",
              },
            }}
          >
            <path
              d="M1.22878 274.892C-0.195964 302.827 -2.70763 331.854 9.48348 358.445C17.4151 375.752 31.9563 391.266 52.6077 402.776C76.5934 416.134 105.911 425.306 135.419 431.341C151.973 434.73 169.305 436.466 186.607 435.892C216.468 434.898 244.522 426.692 266.554 412.97C278.569 405.479 288.822 396.713 297.355 387.275C328.861 352.41 338.203 311.299 340.024 271C340.553 259.21 340.524 247.42 340.347 235.63C339.848 202.654 346.237 168.11 327.378 136.759C322.398 128.498 315.73 120.712 307.446 113.781C296.944 105.016 285.017 96.6702 277.996 86.2665C270.035 74.4765 270.564 61.3002 270.77 48.6141C271.005 33.7156 269.066 18.2429 250.383 8.48329C223.577 -5.51908 183.787 0.880002 154.029 6.01887C122.317 11.4938 86.2581 15.6665 67.4133 36.124C37.2293 68.8895 27.6526 107.872 18.4138 145.398C13.4199 165.702 9.27785 186.103 6.31086 206.589C3.75513 224.274 2.13944 242.015 1.80162 259.784C1.71349 264.783 1.47848 269.838 1.22878 274.92"
              fill={color}
            />
          </StyledDiv>
        </div>
      ),
    },
    // 3 element--------------------------------
    {
      deco: margauxMotinImages.decoBox3,
      productImage: margauxMotinImages.productCaliforniaGourmand,
      renderTopImage: () => (
        <DecorationBox
          imageName="productCaliforniaGourmand"
          styles={{
            marginBottom: -52,
            marginLeft: "auto",
            position: "relative",
            zIndex: 1,
            transform: "translate(-62%, -20%)",
            mobile: {
              transform: "translate(-86%, -20%)",
            },
          }}
          enableAnimation={true}
          animationType="slideDown"
          animationDelay={100}
          animationDistance={200}
          threshold={0.1}
        />
      ),
      renderBottomImage: () => (
        <DecorationBox
          imageName="decoBox3"
          styles={{
            position: "absolute",
            bottom: 0,
            right: 0,
            transform: "translate(17%, 24%)",
            mobile: {
              transform: "translate(0%, 17%)",
              img: {
                maxWidth: "272px",
              },
            },
          }}
          enableAnimation={true}
          animationType="slideLeft"
          animationDelay={100}
          animationDistance={200}
          threshold={0.1}
        />
      ),
      color: "#FBCFAC",
      maxWidth: 275,
      bgSvg: (color: string) => (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 0,
            overflow: "visible",
            pointerEvents: "none",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="406"
            height="452"
            viewBox="0 0 406 452"
            fill="none"
            style={{
              transform: "translate(-20%, 6%)",
            }}
          >
            <path
              d="M69.0453 380.984C87.3034 413.35 110.388 451.297 167.64 451.024C215.508 450.796 271.236 433.632 309.408 402.144C329.511 385.556 344.887 365.067 358.654 346.186C373.141 326.33 385.078 305.948 391.917 285.345C406.287 242.017 408.479 196.941 402.854 156.794C397.487 118.486 381.582 82.0805 358.75 50.7018C340.321 25.3729 314.073 3.20605 270.233 0.447582C246.092 -1.07514 219.664 3.81322 194.476 12.4901C132.745 33.7448 63.0145 57.8404 23.3416 104.856C-12.0902 146.846 2.54448 193.215 12.5089 229.863C25.0275 275.946 39.3788 322.169 60.5747 364.962C63.254 370.37 66.0648 375.726 69.051 380.998"
              fill={color}
            />
          </svg>
        </div>
      ),
    },
  ];
